import { withDependencies } from '@wix/thunderbolt-ioc'
import type { BrowserWindow } from '@wix/thunderbolt-symbols'
import { BrowserWindowSymbol } from '@wix/thunderbolt-symbols'
import type { ISiteScrollBlocker, IScrollBlockedListener } from 'feature-site-scroll-blocker'
import { SiteScrollBlockerSymbol } from 'feature-site-scroll-blocker'
import type { IDynamicActionsApi } from './types'
import { DynamicActionsApiSymbol } from './symbols'
import { isSafari, isChromeOnIos, isIOS11Device } from '@wix/thunderbolt-commons'
import type { ComponentWillMount, ViewerComponent } from 'feature-components'

const componentType = 'QuickActionBar'

const quickActionBarFactory = (
	siteScrollBlocker: ISiteScrollBlocker,
	window: BrowserWindow,
	dynamicActions: IDynamicActionsApi
): ComponentWillMount<ViewerComponent> => {
	let scrollBlockedListenerId: unknown

	const getOnScrollBlocked = (component: ViewerComponent): IScrollBlockedListener => ({
		handleBlockedBy(blockedCompId) {
			if (blockedCompId !== component.id) {
				component.updateProps({ isHidden: true })
			}
		},
		handleUnblockedBy(unblockedCompId) {
			if (unblockedCompId !== component.id) {
				component.updateProps({ isHidden: false })
			}
		},
	})

	const shouldSetPositionAbsoluteAtPageBottom = isIOS11Device(window!) && (isChromeOnIos(window!) || isSafari(window!))

	return {
		componentTypes: [componentType],
		componentWillMount(component) {
			component.updateProps({
				onOpen() {
					siteScrollBlocker.setSiteScrollingBlocked(true, component.id)
				},
				onClose() {
					siteScrollBlocker.setSiteScrollingBlocked(false, component.id)
				},
				shouldSetPositionAbsoluteAtPageBottom,
			})

			dynamicActions.updateQABComponentProps()
			scrollBlockedListenerId = siteScrollBlocker.registerScrollBlockedListener(getOnScrollBlocked(component))
			return () => {
				siteScrollBlocker.unRegisterScrollBlockedListener(scrollBlockedListenerId)
			}
		},
	}
}

export const QuickActionBar = withDependencies(
	[SiteScrollBlockerSymbol, BrowserWindowSymbol, DynamicActionsApiSymbol],
	quickActionBarFactory
)
